<template>
  <div class="mt-5">
    <b-tabs>
      <b-tab title="Latest Earnings">
        <b-table 
          class="table-header" 
          :items="latest_earnings" 
          :fields="earningsFields"
          >
        </b-table>
      </b-tab>

      <b-tab title="Latest Affiliates">
        <b-table class="table-header" :items="latest_affs" :fields="affiliatesFields"></b-table>
      </b-tab>
    </b-tabs> 
  </div>
</template> 

<script>
  import{
    BTabs,
    BTab,
    BTable,
  } from "bootstrap-vue"

  export default {
    name: "AffiliateTable",
    components: {
      BTabs,
      BTab,
      BTable,
    },
    props:[
      "latest_earnings",
      "latest_affs"
    ],
    data () {
      return {
        earningsFields:['date','affiliate','zoom_earned'],
        affiliatesFields:['date_linked', 'affiliate_address'],
      }
    }
  }
</script>

<style lang="scss" scoped>
  .table-header{
    font-family: "Truculenta", sans-serif;
    font-size: 20px;

    color: white;
    border-radius: 25px;

  }
</style>